export const selectCurrentUser = (state) => state.user.currentUser;

export const selectError = (state) => state.user.error;